/**
 * Created by Victor Rojo on 4/9/17.
 */
export class Credential{
  constructor(public username: string, public password: string){}
}
